// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
import $ from "jquery";

// MAKE BOOTSTRAP GLOBAL
window.bootstrap = bootstrap

//
//
// MOBILE MENUE
document.addEventListener('turbo:load', () => {
  $('#navbar_top ul li.dropdown > a').click(function(e) {
    if ($(window).width() <= 1199.98){
      if ($(this).next('ul').is(':hidden') ) {
        $('#navbar_top ul li.dropdown ul').hide();
        $(this).next('ul').show();
      } else {
        $(this).next('ul').hide();
      }

      e.preventDefault();
    }
  });
});
